import sortBy from 'lodash/sortBy';
import { fg } from '@atlassian/jira-feature-gating';
import type { Goal, LazyGoal } from '@atlassian/jira-portfolio-3-atlas-goals';
import type { State } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/state/types';
import { createSelector } from '@atlassian/jira-portfolio-3-portfolio/src/common/reselect';

export const getIssueGoalARIs = (state: State): string[] => state.domain.goals.goalARIs;

export const getLazyGoalsByARI = (state: State): Record<string, LazyGoal> =>
	state.domain.goals.lazyGoalsByARI;

export const getGoalSearchesInProgress = (state: State) => state.domain.goals.searchesInProgress;

export const getIsGoalError = (state: State) => state.domain.goals.isError;

const sortLazyGoals = (goals: LazyGoal[]) => sortBy(goals, (goal) => goal.goal?.name);

export const getAllLazyGoalsPure = (lazyGoalsByARI: Record<string, LazyGoal>) => {
	if (!fg('plan_timeline_sort_goal_groups_alphabetically')) return [];

	return sortLazyGoals(Object.values(lazyGoalsByARI));
};

export const getAllLazyGoals = createSelector([getLazyGoalsByARI], getAllLazyGoalsPure);

export const getDefinedGoalsPure = (lazyGoalsByARI: Record<string, LazyGoal>) => {
	if (!fg('plan_timeline_sort_goal_groups_alphabetically')) return {};

	return Object.entries(lazyGoalsByARI).reduce<Record<string, Goal>>((acc, [goalARI, lazyGoal]) => {
		if (lazyGoal.goal !== undefined && !lazyGoal.isLoading) {
			const { goal } = lazyGoal;
			acc[goalARI] = goal;
		}
		return acc;
	}, {});
};

export const getDefinedGoals = createSelector([getLazyGoalsByARI], getDefinedGoalsPure);

export const getIsGoalsLoadingPure = (lazyGoalsByARI: Record<string, LazyGoal>) => {
	if (!fg('plan_timeline_sort_goal_groups_alphabetically')) return false;

	return Object.values(lazyGoalsByARI).some((lazyGoal) => lazyGoal.isLoading);
};

export const getIsGoalsLoading = createSelector([getLazyGoalsByARI], getIsGoalsLoadingPure);
